module.exports = __webpack_public_path__ + "static/cardstructure-collections-1ecf6be030d950b97510a5800e73c2c1.png";